import { useEffect } from 'react';
import type { User } from '@axiom/validation';

import { NotificationsApi } from '../../api/notifications-api';

export const useNotificationsRefresher = (userId: User['id']) => {
  useEffect(() => {
    const fetchInterval = setInterval(() => {
      void NotificationsApi.refreshNotifications(userId);
    }, 60000); // 60 Seconds

    return () => {
      clearInterval(fetchInterval);
    };
  }, []);
};
